import { Link } from "@reach/router";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden, Typography } from "@material-ui/core";
import phone from "../../images/smartphoneHero.svg";
import dhbwlogo from "../../images/dhbw-logo.svg";
import moslogo from "../../images/stadt-mosbach-logo.svg";
import HeartLogo from "../HeartLogo.jsx";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    background:
      "linear-gradient(300deg, rgba(14,77,164,1) 0%, rgba(14,77,164,1) 35%, rgba(255,255,255,1) 35%)",
  },
  heartLogo: {
    maxWidth: "20rem",
  },
  textBox: {
    position: "relative",
    maxWidth: "35rem",
    top: "40%",
    transform: "translateY(-50%)",
  },
  title: {
    fontSize: "3rem",
  },
  phone: {
    position: "relative",
    maxHeight: "75vh",
    marginLeft: "2rem",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -25%)",
  },
  logoBox: {
    marginTop: theme.spacing(4),
  },
  logo: {
    display: "inline-block",
    width: "10rem",
    marginRight: "5rem",
  },
  info: {
    position: "absolute",
    bottom: "0",
    right: "0",
    marginRight: "1rem",
    marginBottom: "1rem",
  },
  link: {
    color: "white",
  },
}));

function DesktopLandingpage() {
  const classes = useStyles();
  function GridWrapper() {
    return <Grid item xs={1} lg={2} />;
  }

  return (
    <>
      <div className={classes.root}>
        <Grid container>
          <GridWrapper />
          <Grid item xs={10} lg={8}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <div className={classes.heartLogo}>
                  <HeartLogo />
                </div>
                <div className={classes.textBox}>
                  <Typography className={classes.title} variant="h5" gutterBottom>
                    Fitness Trail Mosbach
                  </Typography>
                  <Typography variant="body1">
                    Dieser Parcours entstand im Rahmen der Kooperation zwischen der DHBW Mosbach und
                    der Stadt Mosbach. Getreu dem Motto „Trimm Dich durch Sport“ wünschen wir allen
                    Aktiven viel Spaß beim Sport treiben unter freiem Himmel in Mosbach. <br />
                    Jetzt App downloaden und Mosbach neu entdecken!
                  </Typography>
                  <div className={classes.logoBox}>
                    <img className={classes.logo} src={dhbwlogo} alt="Logo DHBW" />
                    <img className={classes.logo} src={moslogo} alt="Logo Stadt Mosbach" />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Hidden smDown>
                  <img src={phone} className={classes.phone} alt="Fitness Trail Mosbach App" />
                </Hidden>
                <div className={classes.info}>
                  <Link to="/privacy" className={classes.link}>
                    Datenschutz
                  </Link>
                  <span style={{ margin: "0 5", color: "#fff" }}> - </span>
                  <Link to="/impressum" className={classes.link}>
                    Impressum
                  </Link>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <GridWrapper />
        </Grid>
      </div>
    </>
  );
}

export default DesktopLandingpage;
